import { RootUserApi } from "@/api";
import { showSuccessSnackbar } from "@/utilities/snackbar";
import i18n from "@/i18n";

export async function getAllRootUsers(params) {
  const { data } = await RootUserApi.getRootUsers(params);
  return data;
}

export async function registerRootUser(data) {
  const { data: response } = await RootUserApi.registerRootUser(data);
  showSuccessSnackbar(200, i18n.t("root-user-created-successfully"));
  return response;
}
